import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                  久久久久
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                专注持久稳定的极致体验
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">
                产品分类
              </h4>
              <ul className="flex flex-col gap-3">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-3">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-sm"></i>
                  </span>
                  contact@jiujiujiujiu.com
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-sm"></i>
                  </span>
                  400-888-9999
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-sm"></i>
                  </span>
                  中国上海市浦东新区
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 久久久久 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}